import React, { Fragment } from 'react';
import './PreFooter.css';

const PreFooter = (props) => {
	return (
		<Fragment>
			<section className="pre__footer">
				<div>
					<h1>boost your links today</h1>
					<button>Get Started</button>
				</div>
			</section>
		</Fragment>
	);
};

export default PreFooter;
